export default () => {
  const links = document.querySelectorAll('[data-scroll-to]');

  if (links.length) {
    links.forEach((el) => {
      // selectors
      const els = {
        offset: document.querySelector('[data-scroll-to-offset]'),
      };

      // event listeners
      el.addEventListener('click', (e) => {
        const link = e.currentTarget;
        const scrollToEl = document.getElementById(link.hash.substring(1));
        const scrollToPos = scrollToEl.getBoundingClientRect().top
          + window.pageYOffset - els.offset.offsetHeight;

        e.preventDefault();
        window.scrollTo({ behavior: 'smooth', top: scrollToPos });
      });
    });
  }
};
